import React, { useState } from 'react';
import '../styles/NovationTimeline.css';
import { colour, formatterLong } from '../styles/GlobalStyles';
import { HugeiconsIcon } from '@hugeicons/react';
import { Clock05Icon } from '@hugeicons/core-free-icons';

function NovationTimeline(props) {
    const property = props.property;
    const data = property.novationTimeline;
    const innerWidth = props.innerWidth;
    const darkMode = props.darkMode;
    const abstractTextIndex = data.findIndex(e => e.text !== null);
    const [expanded, setExpanded] = useState(false);

    const showExpanded = () => {
        if ( innerWidth < 1000 ) {
            return;
        }
        setExpanded(true);
    };

    const hideExpanded = () => {
        setExpanded(false);
    };

    return (
        <div 
            className={"novation-timeline-container " + (expanded === true ? "novation-timeline-expanded" : "")}
        >
            <div 
                className={"novation-timeline-abstract-element " + (expanded ? "novation-timeline-hidden" : "novation-timeline-visible")}
                onMouseEnter={() => showExpanded()}
            >
                <HugeiconsIcon
                    icon={Clock05Icon}
                    size={14}
                    color={darkMode === true ? colour.gray05 : colour.gray04}
                />
                <span className={darkMode === true ? data[abstractTextIndex].textColour.replace("-green", "-green-02").replace("-error", "-red-02").replace("-orange", "-orange-02") : data[abstractTextIndex].textColour}>
                    {data[abstractTextIndex].text}
                </span>
            </div>
            <div 
                className="novation-timeline-body-container"
                onMouseLeave={() => hideExpanded()}
            >
                {
                    data.map((item, index) => {
                        let borderClass = item.border;
                        if (data.length > 1 && index === 0 && item.textColour) {
                            // Extract color from textColour and match it to border
                            if (item.textColour.includes("green")) {
                                borderClass = "novation-timeline-element-border-green";
                            } else if (item.textColour.includes("orange")) {
                                borderClass = "novation-timeline-element-border-orange";
                            } else if (item.textColour.includes("error")) {
                                borderClass = "novation-timeline-element-border-red";
                            } else {
                                borderClass = "novation-timeline-element-border-default";
                            }
                        }
                        return (
                        <div 
                            className={"novation-timeline-element relative-container " + borderClass}
                            key={index}
                        >
                            <div className="novation-timeline-dot">
                            </div>
                            <div className="novation-timeline-inner-container">
                                <span className={"label-regular-caps " + (darkMode === true ? "colour-tertiary" : "colour-secondary")}>
                                    {item.date}
                                </span>
                                <span className={"body-semibold " + (darkMode === true ? "colour-white" : "colour-primary")}>
                                    {item.label}
                                </span>
                                <span className={"body-regular " + (darkMode === true ? "colour-white" : "colour-primary")}>
                                    {formatterLong.format(item.price).replace(".00", "")}
                                </span>
                                {
                                    item.difference !== null &&
                                    <span className={"body-regular text-italic " + (item.difference[0] === "-" ? (darkMode === true ? "colour-red-02" : "colour-error") : (darkMode === true ? "colour-green-02" : "colour-green"))}>
                                        {item.difference}
                                    </span>
                                }
                            </div>
                            {
                                item.text !== null &&
                                <div className="novation-timeline-extra-text-container">
                                    <span className={darkMode === true ? item.textColour.replace("-green", "-green-02").replace("-error", "-red-02").replace("-orange", "-orange-02") : item.textColour}>
                                        {item.text}
                                    </span>
                                    {
                                        item.subText !== null &&
                                        <span className={darkMode === true ? item.subTextColour.replace("-secondary", "-tertiary") : item.subTextColour}>
                                            {item.subText}
                                        </span>
                                    }
                                </div>
                            }
                        </div>
                        );
                    })
                }
            </div>
        </div>
    )
};

export default NovationTimeline;